import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { courseSelectionContent } from '../content';

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introductory section explaining what course selection is and why it matters for colleges, employers, and personal growth.',
    detail: [
      courseSelectionContent.header.description.join('\n'),
      'Discussion questions:',
      ...courseSelectionContent.discussionQuestions.questions,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: courseSelectionContent.beyondCollege.title,
    description:
      'Explains the broader value of thoughtful course selection beyond college admissions, including career exploration, skill building, scholarships, and recommendations.',
    detail: [
      courseSelectionContent.beyondCollege.intro,
      ...courseSelectionContent.beyondCollege.items.map(
        (item) => `${item.label}: ${item.description}`,
      ),
      courseSelectionContent.beyondCollege.conclusion,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: courseSelectionContent.tools.title,
    description: 'Backrs tools to support course selection planning.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: courseSelectionContent.keyPrinciples.title,
    description: 'Five key principles for choosing high school courses wisely.',
    detail: courseSelectionContent.keyPrinciples.principles
      .map((p) => `${p.number}. ${p.title}: ${p.body}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: courseSelectionContent.mythsAndMistakes.title,
    description:
      'Ten common myths and mistakes in course selection, covering AP overload, GPA gaming, prerequisites, and more.',
    detail: [
      courseSelectionContent.mythsAndMistakes.intro,
      ...courseSelectionContent.mythsAndMistakes.items.map(
        (item) => `${item.type === 'myth' ? 'Myth' : 'Mistake'}: ${item.title} — ${item.body}`,
      ),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: courseSelectionContent.strategyByGoal.title,
    description:
      'Tailored course selection strategies for different student paths: college-bound, career/technical, and exploratory.',
    detail: courseSelectionContent.strategyByGoal.strategies
      .map((s) => `${s.title}: ${s.points.join('; ')}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: courseSelectionContent.faq.title,
    description: 'Frequently asked questions about course selection timing, changes, and rigor.',
    detail: courseSelectionContent.faq.questions
      .map((q) => `Q: ${q.question} A: ${q.answer}`)
      .join('\n'),
  });
};
